<template>
  <li
    v-if="region.total_site_count > 0 || region.id === getGlobalRegion.id"
    class="w-full"
  >
    <button
      v-if="region.child_sites.length > 0 || region.id === getGlobalRegion.id"
      class="w-full sticky top-12 md:top-0 flex items-center px-4 py-1.5 text-left text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-gray-600 bg-gray-50 dark:bg-navy-800 border dark:border-gray-600 group"
      @mouseenter="$emit('highlightRegion', region.id)"
      @mouseleave="$emit('clearRegionHighlight', region.id)"
      @click="$emit('clickRegion', region.id)"
    >
      <h3 class="mr-2 text-left font-semibold text-xs text-gray-800 dark:text-white/80">
        <span
          v-if="levels.length > 1"
          class="text-gray-600 dark:text-gray-400"
        >
          <font-awesome-icon icon="fa-solid fa-house" class="text-gray-400 mr-1" />
          <font-awesome-icon icon="fa-solid fa-chevron-right" class="text-gray-400 mx-1" />
        </span>
        <span
          v-for="(level, idx) of levels.slice(1, -1)"
          :key="idx"
          class="text-gray-500 dark:text-gray-400 font-medium"
        >
          {{ level.region_name }}
          <font-awesome-icon icon="fa-solid fa-chevron-right" class="text-gray-400 mx-1" />
        </span>
        <span><font-awesome-icon icon="fa-solid fa-map-location-dot" class="mx-1" /></span>
        {{ region.region_name }}
        <span class="ml-1 text-xs font-normal text-gray-500 dark:text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-200">
          ({{ region.total_site_count }} total site{{ region.total_site_count !== 1 ? 's' : '' }}<span v-if="region.subregion_site_count > 0"> – {{ region.subregion_site_count }} in subregions</span>)
        </span>
      </h3>
    </button>

    <ul class="w-full">
      <li
        v-for="site in region.child_sites"
        :key="site.id"
        class="w-full bg-white hover:bg-gray-50 dark:bg-navy-1000 dark:hover:bg-input-darkhovered border-b dark:border-gray-700 grid grid-cols-12"
        @mouseenter="$emit('highlightSite', site.id)"
        @mouseleave="$emit('clearSiteHighlight', site.id)"
      >
        <button v-if="screen.md" @click="$emit('focusSite', site.id)" class="rounded-md bg-secondary-400 hover:bg-secondary-700 dark:bg-secondarydark/40 dark:border dark:border-secondary-400/20 dark:shadow-primarydark/30 h-10 w-10 p-2.5 self-center ml-3 col-span-2">
          <font-awesome-icon icon="fa-solid fa-eye" class="text-white" />
        </button>
        <button @click="$emit('navigateToSite', site.id)" class="p-5 col-span-12 md:col-span-10">
          <p class="text-sm uppercase font-bold text-secondary-400 dark:text-secondary-50 text-center">
            {{ site.name }}
            <span v-if="alerts[site.id]" class="rounded-lg bg-red-500 text-white ml-1 px-1.5 text-sm">
              {{ alerts[site.id] }}
            </span>
          </p>
          <p class="mt-2 text-sm text-gray-500 dark:text-gray-400 text-center">
            {{ site.address }}
          </p>
          <!-- Weather -->
          <div v-if="siteWeather[site.id]" class="flex items-center justify-center gap-1.5 mt-2">
            <img
              v-if="siteWeather[site.id].weather"
              :src="`https://openweathermap.org/img/wn/${siteWeather[site.id].weather[0].icon}.png`"
              :alt="siteWeather[site.id].weather[0].description"
              class="w-6 h-6"
            >
            <span class="text-xs font-semibold text-gray-600">
              {{ Math.floor(siteWeather[site.id].main.temp) }}°F
            </span>
            <span v-if="siteWeather[site.id].weather" class="text-xs text-gray-400">
              {{ siteWeather[site.id].weather[0].description.replace(/\b\w/g, l => l.toUpperCase()) }}
            </span>
          </div>
        </button>
      </li>
    </ul>

    <!-- Recursively render subregions -->
    <ul v-if="Array.isArray(region.child_regions)">
      <SiteMapRegionList
        v-for="subregion in region.child_regions"
        :key="subregion.id"
        :region="subregion"
        :screen="screen"
        :alerts="alerts"
        :get-sites-obj="getSitesObj"
        :site-weather="siteWeather"
        :levels="[ ...levels, {
          id: subregion.id,
          region_name: subregion.region_name
        }]"
        @highlight-region="$emit('highlightRegion', $event)"
        @clear-region-highlight="$emit('clearRegionHighlight', $event)"
        @click-region="$emit('clickRegion', $event)"
        @highlight-site="$emit('highlightSite', $event)"
        @clear-site-highlight="$emit('clearSiteHighlight', $event)"
        @focus-site="$emit('focusSite', $event)"
        @navigate-to-site="$emit('navigateToSite', $event)"
      />
    </ul>
  </li>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "SiteMapRegionList",
  props: {
    region: Object,
    screen: Object,
    alerts: Object,
    getSitesObj: Object,
    siteWeather: {
      type: Object,
      default: () => ({})
    },
    levels: Array
  },
  emits: [
    "highlightRegion",
    "clearRegionHighlight",
    "clickRegion",
    "highlightSite",
    "clearSiteHighlight",
    "focusSite",
    "navigateToSite"
  ],
  computed: {
    ...mapGetters([
      "getGlobalRegion"
    ])
  },
}
</script>
